import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { Observable, ReplaySubject } from "rxjs";

import { Configuration } from "@/shared-module/models";

@Injectable({ providedIn: "root" })
export class ConfigurationService {
  private dataSubject = new ReplaySubject<Configuration>(1);
  configuration: Observable<Configuration> = this.dataSubject.asObservable();
  fetched: boolean;
  configurationValue: Configuration;
  demoPopup: boolean;
  launchPopupAlreadyDisplayed: boolean;
  firstAccess: boolean;
  constructor(private http: HttpClient, private router: Router) {
    this.configuration.subscribe((c) => (this.configurationValue = c));
  }

  setDemoPopup(value: boolean) {
    this.demoPopup = value;
  }

  displayDemoPopup() {
    return this.demoPopup;
  }

  setLaunchPopupAlreadyDisplayed(value: boolean) {
    this.launchPopupAlreadyDisplayed = value;
  }

  isLaunchPopupAlreadyDisplayed() {
    return this.launchPopupAlreadyDisplayed;
  }

  public get config(): any {
    if (!this.fetched) {
      this.http
        .get<Configuration>(`api/configuration`)
        .subscribe((res) => this.dataSubject.next(res));
      this.fetched = true;
    }
    return this.configuration;
  }

  public refreshConfig(): any {
    return this.http
      .get<Configuration>(`api/configuration`)
      .subscribe((res) => this.dataSubject.next(res));
  }

  public redirectIfDisabled() {
    if (this.configurationValue.noRankingMode) {
      let url = this.configurationValue.menu.items[0].path;
      if (url == null)
        //case of "select teams when coming from faculty user interface"
        url = this.configurationValue.menu.items[1].path;
      this.router.navigateByUrl(url, { skipLocationChange: false });
    }
  }

  public setLanguage(language: string) {
    return this.http
      .post(`api/configuration/language/${language}`, null)
      .pipe((s) => {
        return s;
      });
  }

  public setHighContrast() {
    return this.http
      .post(`api/configuration/highcontrast/set`, null)
      .pipe((s) => {
        return s;
      });
  }

  public unsetHighContrast() {
    return this.http
      .post(`api/configuration/highcontrast/unset`, null)
      .pipe((s) => {
        return s;
      });
  }

  public setScreenReaderFriendly() {
    return this.http
      .post(`api/configuration/screenreaderfriendly/set`, null)
      .pipe((s) => {
        return s;
      });
  }

  public unsetScreenReaderFriendly() {
    return this.http
      .post(`api/configuration/screenreaderfriendly/unset`, null)
      .pipe((s) => {
        return s;
      });
  }

  getDemoParameters() {
    return this.http
      .get<string>(`api/configuration/demoparameters`)
      .pipe((s) => {
        return s;
      });
  }
}
